import React from 'react';
import { HiMoon, HiSun } from 'react-icons/hi2';
import { useTheme } from '../context/ThemeContext';

/**
 * Dark Mode Toggle Component
 * Button to toggle between light and dark themes
 */
const DarkModeToggle = ({ className = '', showLabel = false, onClick }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    toggleTheme();
  };

  return (
    <button
      onClick={handleClick}
      className={`
        relative inline-flex items-center justify-center
        w-10 h-10 md:w-11 md:h-11
        rounded-xl
        bg-gray-100 dark:bg-gray-800
        hover:bg-gray-200 dark:hover:bg-gray-700
        text-gray-700 dark:text-gray-200
        transition-all duration-300
        transform hover:scale-110 active:scale-95
        focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2 dark:focus:ring-offset-gray-800
        shadow-md hover:shadow-lg
        ${className}
      `}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Icon with smooth transition */}
      <div className="relative w-5 h-5 md:w-6 md:h-6">
        <HiSun
          className={`
            absolute inset-0
            w-full h-full
            transition-all duration-300
            ${isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'}
            text-orange-500
          `}
        />
        <HiMoon
          className={`
            absolute inset-0
            w-full h-full
            transition-all duration-300
            ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'}
            text-blue-400
          `}
        />
      </div>
    </button>
  );
};

export default DarkModeToggle;

